import { takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import { submitChampionRequest, submitChampionSuccess, submitChampionFailure, SUBMIT_CHAMPION_REQUEST } from "../actions/championAgentActions";
import { fetchChampionAgent } from "../../../services/accIqService";

function* submitChampionSaga(action) {
  try {
    const response = yield call(
      fetchChampionAgent,
      action.payload.contact,
      action.payload.context,
      action.payload.requestType
    );
    yield put(submitChampionSuccess(response?.html || "No champion note generated."));
  } catch (error) {
    yield put(submitChampionFailure(error.message));
  }
}

export function* watchChampionSaga() {
  yield takeLatest(SUBMIT_CHAMPION_REQUEST, submitChampionSaga);
}